import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { map } from 'rxjs/operators';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';

@Injectable()
export class BdbProductInfoService {
    private productInfoLambdaUrl = environment.productInfoLambdaUrl;

    private products = {};

    constructor(
        private httpClient: HttpClient,
        private bdbSessionStrgService: BdbSessionStrgService
    ) { }

    getProductInfo(): Observable<string> {
        const site = this.bdbSessionStrgService.get(SessionStorageKeysEnum.SITE);
        const savedProductInfo = this.products[site];
        if (savedProductInfo !== undefined) {
            console.log('Cached ProductName: ', savedProductInfo['productName']);
            return new Observable(observer => {
                observer.next(savedProductInfo);
                observer.complete();
            });
        }
        console.log('getting product info for site: ' + site);
        return this.httpClient.get<string>(this.productInfoLambdaUrl, {
            params: {
                site: site
            }
        }).pipe(map(productInfo => {
            this.products[site] = productInfo;

            // Expected values: 'true', 'false', 'null'.
            this.bdbSessionStrgService.save('allowCellphone', productInfo['productCellphone']);
            return productInfo;
        }));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/bdb-product-info.service.ts